var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShareIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_93_2551)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5602 14.08C13.8306 14.08 13.1778 14.38 12.6786 14.85L5.83376 10.7C5.88176 10.47 5.92016 10.24 5.92016 10C5.92016 9.76 5.88176 9.53 5.83376 9.3L12.6018 5.19C13.1202 5.69 13.8018 6 14.5602 6C16.1538 6 17.4402 4.66 17.4402 3C17.4402 1.34 16.1538 0 14.5602 0C12.9666 0 11.6802 1.34 11.6802 3C11.6802 3.24 11.7186 3.47 11.7666 3.7L4.99856 7.81C4.48016 7.31 3.79856 7 3.04016 7C1.44656 7 0.160156 8.34 0.160156 10C0.160156 11.66 1.44656 13 3.04016 13C3.79856 13 4.48016 12.69 4.99856 12.19L11.8338 16.35C11.7858 16.56 11.757 16.78 11.757 17C11.757 18.61 13.0146 19.92 14.5602 19.92C16.1058 19.92 17.3634 18.61 17.3634 17C17.3634 15.39 16.1058 14.08 14.5602 14.08Z",
    fill: "#FD8061"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_93_2551"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.28,
    height: 20,
    fill: "white",
    transform: "translate(0.160156)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/shareIcon.113a4e75a90b0febfbf5eb822e48c183.svg";
export { ForwardRef as ReactComponent };